import * as R from 'ramda';

//Adapt reponse from devices_v2 event to devices
export default parks => {
    return (
        R.flatten(parks.map(park => park.subparks.map(subpark => ({ ...subpark, wtgs: subpark.wtgs.map(wtg => ({ ...wtg, realtime: wtg.realtime_v2 })) }))))
    );
};